import LocalImage from "@common/components/LocalImage";
import { useTranslation } from "next-i18next";
import { ReactNode, useMemo } from "react";
import { ArrowRightIcon } from "@talladega/icons";
import {
  GaugeCircleGray,
  MoneyCircleGray,
  LightningCircleGray,
} from "public/images/purchase/consumer";

import { Button } from "@talladega/components";
import {
  FinancingPreQualificationMode,
  personalInfoMode,
} from "../types/FinancingPreQualificationMode";

type CreditAppIntroProps = {
  onChangeMode(newMode: FinancingPreQualificationMode): void;
};

type Labels = {
  label: string;
  subLabel: string;
  icon: ReactNode;
  id: number;
};

const FinancingPreQualificationIntroduction = ({
  onChangeMode,
}: CreditAppIntroProps) => {
  const { t } = useTranslation(["common", "purchase"]);

  const onStartPreQualForm = () => {
    onChangeMode(personalInfoMode);
  };

  const labelList: Labels[] = useMemo(
    () => [
      {
        label: t("common:take_less_than", {
          minutes: 2,
        }),
        subLabel: t(
          "purchase:get_started_by_providing_basic_info_and_location_details"
        ),
        icon: (
          <LocalImage
            className="m-auto w-12 h-12"
            src={LightningCircleGray}
            alt={t(
              "purchase:get_started_by_providing_basic_info_and_location_details"
            )}
          />
        ),
        id: 1,
      },
      {
        label: t("purchase:doesnt_affect_credit_score"),
        subLabel: t("purchase:dont_worry_pre_qual_doesnt_affect_credit_score"),
        icon: (
          <LocalImage
            className="m-auto w-12 h-12"
            src={GaugeCircleGray}
            alt={t("purchase:dont_worry_pre_qual_doesnt_affect_credit_score")}
          />
        ),

        id: 2,
      },
      {
        label: t("purchase:get_sense_of_budget"),
        subLabel: t("purchase:we_will_help_give_sense_of_what_can_afford"),
        icon: (
          <LocalImage
            className="m-auto w-12 h-12"
            src={MoneyCircleGray}
            alt={t("purchase:we_will_help_give_sense_of_what_can_afford")}
          />
        ),
        id: 3,
      },
    ],
    [t]
  );

  return (
    // <div className="mb-5 lg:w-5/6 md:w-3/4 sm:w-4/5 flex flex-col items-center">
    <div className="mb-5 flex flex-col items-center w-full">
      <div className="block w-full">
        {labelList.map((item) => (
          <div
            key={item.id}
            className="flex flex-row items-start gap-4 y-3 lg:py-3 lg:leading-5 mt-6 lg:mt-0"
          >
            <div className="inline-flex items-center justify-center rounded-full p-1">
              {item.icon}
            </div>
            <div className="flex-1">
              <p className="font-bold text-left text-primary">{item.label}</p>
              <p className="text-secondary text-left my-2">{item.subLabel}</p>
            </div>
          </div>
        ))}
      </div>
      <Button
        className="mt-6"
        spacing="tight-hug"
        rightIcon={<ArrowRightIcon className="h-5 w-5" />}
        onClick={onStartPreQualForm}
      >
        {t("purchase:get_pre_approved")}
      </Button>
    </div>
  );
};

export default FinancingPreQualificationIntroduction;
